import { CopyPayLinkButton } from "@/features/invoices/components/CopyPayLinkButton";

interface InvoiceRowActionsCellProps {
  payLinkUrl: string | null | undefined;
  /** When true, only show Open (no Copy). */
  openOnly?: boolean;
}

function openPayLinkInNewTab(url: string) {
  window.open(url, "_blank", "noopener,noreferrer");
}

export function InvoiceRowActionsCell({
  payLinkUrl,
  openOnly = false,
}: InvoiceRowActionsCellProps) {
  const hostedUrl = payLinkUrl?.trim();

  if (!hostedUrl) {
    return <span className="cell-meta shrink-0">No link</span>;
  }

  return (
    <div className="cell-inline-actions invoice-row-actions">
      {!openOnly ? (
        <CopyPayLinkButton url={hostedUrl} className="btn-paylink-action" />
      ) : null}
      <a
        href={hostedUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-row-dl btn-paylink-action secondary shrink-0"
        onClick={(e) => {
          e.preventDefault();
          openPayLinkInNewTab(hostedUrl);
        }}
      >
        Open
      </a>
    </div>
  );
}
